function formatSelectOptions(options = []) {
    return options
        .map((opt) => {
            if (typeof opt === 'string') {
                return { value: opt, label: opt };
            }

            if (typeof opt === 'object' && opt != null && 'value' in opt && 'label' in opt) {
                return opt;
            }

            return null;
        })
        .filter(Boolean);
}

function getOptionLabel(value, options = []) {
    const stringValue = value == null ? '' : String(value);
    const match = options.find((opt) => String(opt?.value ?? opt) === stringValue);
    return match?.label ?? (value == null ? '' : String(value));
}

function enrichSelectFilterChipLabels(filters, filterKey, options, label) {
    if (!filters || options.length === 0) {
        return filters;
    }

    return filters.map((filter) => {
        if (filter.filterKey !== filterKey) {
            return filter;
        }

        return {
            ...filter,
            chipLabel: `${label}: ${getOptionLabel(filter.data, options)}`,
        };
    });
}

export { enrichSelectFilterChipLabels, formatSelectOptions, getOptionLabel };
